var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _g3, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 51,
    viewBox: "0 0 84 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_1060)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.90938 43.7193H5.4044V45.0641H3.49624V50.8164H1.90938V45.0641H0.0012207V43.7193H1.90938Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_143_1060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 43,
    width: 8,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93115 43.4832H12.0862V50.9998H5.93115V43.4832Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_143_1060)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75038 46.1517C7.97158 44.5124 10.0717 44.4009 10.2706 46.1517C10.3628 46.9689 10.3973 47.773 10.2706 48.5244C9.93176 50.1865 8.03278 49.9162 7.77574 48.5244C7.6682 47.7409 7.63017 46.9193 7.75038 46.1517ZM5.98954 47.0567C5.92615 48.8373 6.56571 50.9959 9.02468 50.9344C11.5226 50.9344 12.0528 48.9558 12.0432 47.0567C12.0047 44.9087 11.0286 43.5867 9.02468 43.5885C6.77685 43.6416 6.06779 45.4183 5.98954 47.0567Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8389 43.7202H18.2051V45.0421H15.4283V46.5261H18.0521V47.8108H15.4283V49.4953H18.3389V50.8173H13.8389V43.7202Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0623 50.8173H42.6596V43.7215H41.0623V50.8173Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8079 50.8173H27.473L27.9919 48.9984L30.0146 49.0015L30.5715 50.8173H32.2873L30.0919 43.7215H27.9936L25.8079 50.8173ZM28.2218 47.7932L29.7746 47.7989L28.9785 44.8986L28.2218 47.7932Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.166 43.7166L35.0283 43.7202C35.9996 45.4156 36.9552 47.0514 37.6424 48.768C37.5804 47.069 37.5401 45.3818 37.5449 43.7202L39.0216 43.7224L38.9928 50.812L37.3224 50.8172C36.3393 49.0779 35.3846 47.3341 34.5444 45.5723L34.6248 50.8172H33.1686L33.166 43.7166Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7712 50.8173H21.3686V43.7215H19.7712V50.8173Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9324 43.7184H47.6187L48.8449 48.5244L50.2739 43.7184H52.7482V50.8172H51.2684V45.187H51.1823L49.5137 50.7058H48.0908L46.5441 45.1843H46.4121V50.8172H44.9324V43.7184Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9971 50.8173H55.6622L56.1811 48.9984L58.2033 49.0015L58.7603 50.8173H60.4761L58.2807 43.7215H56.1824L53.9971 50.8173ZM56.411 47.7932L57.9638 47.7989L57.1682 44.8986L56.411 47.7932Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3842 43.7202H65.8793V45.065H63.9711V50.8173H62.3842V45.065H60.4761V43.7202H62.3842Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1724 50.8173H68.7701V43.7215H67.1724V50.8173Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_143_1060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 43,
    width: 7,
    height: 8
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3916 43.4832H76.5467V50.9998H70.3916V43.4832Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_143_1060)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1984 46.1503C72.4196 44.511 74.5197 44.3996 74.7186 46.1503C74.8108 46.9676 74.8454 47.7721 74.7186 48.5231C74.3798 50.1852 72.4813 49.9148 72.2238 48.5231C72.1163 47.7396 72.0782 46.918 72.1984 46.1503ZM70.4376 47.0554C70.3738 48.836 71.0133 50.9945 73.4727 50.9331C75.9702 50.9331 76.5009 48.9545 76.4913 47.0554C76.4528 44.9074 75.4766 43.5854 73.4727 43.5871C71.2249 43.6407 70.5158 45.4169 70.4376 47.0554Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_143_1060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 43,
    width: 7,
    height: 8
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1135 43.7079H84.0002V50.8989H78.1135V43.7079Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_143_1060)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1526 43.7166L80.0148 43.7202C80.9866 45.4156 81.9422 47.0514 82.6294 48.768C82.5674 47.069 82.5267 45.3818 82.532 43.7202L84.0087 43.7224L83.9802 50.812L82.3095 50.8172C81.3259 49.0779 80.3716 47.3341 79.5309 45.5723L79.6114 50.8172H78.1561L78.1526 43.7166Z",
    fill: "white"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9884 0.951115C39.9104 0.716301 43.2809 4.60982 48.5704 5.71542C52.7111 6.78108 57.24 5.74 61.2679 6.03758C66.8577 6.1754 72.0567 16.6569 64.8853 28.2527C58.707 36.9988 49.0875 38.976 40.8014 38.38C36.7184 37.935 32.9121 36.6564 29.3694 34.5844C26.969 37.0387 24.2386 38.2268 21.8758 38.3238C16.1806 38.3998 15.1717 34.835 16.3961 33.2685C17.2569 32.2116 18.5364 32.0629 19.6166 32.9929L18.9841 29.9921C18.8612 29.6111 19.1296 29.411 19.3875 29.4979L20.5556 29.9996L19.4453 28.9712C19.1886 28.7285 19.2083 28.5986 19.3176 28.398L20.5141 26.3887L20.6059 26.3049C17.5716 21.9803 16.0097 13.6126 20.6828 7.76555C22.9582 4.57076 26.6473 1.22938 31.9884 0.951115Z",
    fill: "#ED1C24"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4307 11.6643C32.9179 11.0999 29.0224 18.0789 28.3466 21.1596C26.9127 26.3303 28.6841 29.9329 31.8836 32.9556C34.6494 35.6092 38.6192 37.1006 42.7428 37.4552C47.263 37.7326 51.0325 36.6556 54.2705 34.0366C57.5854 31.1447 59.0503 26.6595 57.7978 21.8996C55.8346 14.9311 49.2489 12.0422 44.4307 11.6643Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6887 15.8326C41.0885 15.8326 42.2233 16.9654 42.2233 18.3629C42.2233 19.7608 41.0885 20.8936 39.6887 20.8936C38.2889 20.8936 37.1545 19.7608 37.1545 18.3629C37.1545 16.9654 38.2889 15.8326 39.6887 15.8326Z",
    fill: "#ED1C24"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1484 22.525C38.3113 21.2562 35.9196 21.0306 33.8545 21.4603L30.2961 20.2941C29.9818 20.2353 29.8852 20.6465 30.1217 20.7545L33.0476 21.7232C32.4504 22.0286 31.987 22.3846 31.6246 22.7994L29.2448 22.7199C29.052 22.7585 29.0135 23.1794 29.2448 23.1974L31.2924 23.2707C29.7549 25.8914 30.2083 29.5242 31.4847 31.5046C34.2947 35.5517 38.6772 37.152 43.276 37.3925C47.9845 37.4333 51.8555 36.2597 54.3477 32.6848C55.5346 30.8155 55.9381 28.8545 55.8161 26.8272L56.697 27.0756C56.912 27.1357 57.0563 26.6938 56.8089 26.6038L55.6867 26.2878C55.4568 25.5798 55.1145 24.9711 54.6292 24.4887L56.5059 24.339C56.7407 24.2815 56.6755 23.8843 56.4832 23.8729L54.123 24.0621C51.9316 22.5781 49.1382 22.554 46.3312 23.1979C45.6449 20.8054 42.3492 20.7413 41.1484 22.525Z",
    fill: "#ED1C24"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7306 24.6256C41.1479 22.7954 38.0966 21.487 34.853 21.7903L38.7016 23.0697C38.8774 23.1329 38.8407 23.5007 38.6536 23.5213L31.8716 23.2927C30.13 25.6443 30.7975 29.9166 32.0797 31.545C33.9 34.1336 37.4173 36.566 43.1405 36.8943C47.5177 36.9668 51.0686 35.8497 53.3116 33.2453C54.7127 31.3698 55.5717 29.4088 55.2919 26.6819L48.9799 24.9193C48.8199 24.8622 48.7478 24.5374 49.0022 24.4505L53.2697 24.1147C50.9886 22.9306 47.7371 22.9253 43.7306 24.6256Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9743 26.9303L19.9842 28.5569L22.5437 30.9406C22.7081 31.1306 22.434 31.5265 22.1726 31.4207L19.728 30.356L20.5284 34.1499C20.625 34.6362 20.0839 34.7064 19.8714 34.3184C19.3674 33.4761 18.7007 32.9595 17.9265 33.0328C17.1506 33.1026 16.6723 33.879 16.6365 34.4825C16.5053 36.5875 18.5849 37.6137 21.4469 37.6624C24.096 37.6457 26.5235 36.433 28.6481 34.4088L28.0855 33.7311C25.0696 31.742 22.7295 29.4619 20.9743 26.9303Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.564 8.87598C29.4498 10.3582 31.1866 11.9997 32.8399 13.7307L32.8801 13.8496C33.8004 13.2238 34.811 12.7234 35.9717 12.4293C33.1931 10.6461 30.2446 9.24334 27.564 8.87598Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3895 9.39038C29.1421 10.7141 30.8352 12.3363 32.4976 14.1126C30.5104 15.5965 28.9572 17.7274 27.8394 20.5065C26.9039 19.4856 26.4986 17.6874 26.6735 15.0395C27.0617 12.5852 27.425 12.7155 27.5902 11.2891C27.661 10.65 27.6488 10.0145 27.3895 9.39038Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6836 13.8865C53.6414 14.4404 54.5083 15.1589 55.3161 15.9836L55.4324 15.8638C57.6138 14.892 59.7838 13.757 61.935 12.3784C58.9073 11.9773 55.7673 13.384 52.6836 13.8865Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6372 16.3268C57.8977 15.2862 60.1044 14.0524 62.2898 12.7401C62.0332 19.3149 61.8172 19.3693 58.7821 22.5738C58.1377 20.2708 57.2958 18.1435 55.6372 16.3268Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6074 24.1354C37.1053 26.1613 38.7822 24.9675 42.9111 25.5363C46.8638 26.0257 48.2745 28.2773 52.6101 26.8013L47.6651 32.5224C46.2675 34.1323 44.2632 34.8315 41.9887 34.551C40.1938 34.4031 37.5324 32.252 36.7853 30.259L34.6074 24.1354Z",
    fill: "#ED1C24"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8915 31.3356C39.1744 30.4995 40.808 29.777 43.1166 29.9008C44.9631 30.068 46.3397 31.0964 46.4411 32.2731C46.3782 33.3976 44.3673 34.1033 42.8407 34.0015C40.2056 33.6074 38.7879 32.2384 38.8915 31.3356Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8293 21.9707C33.1635 22.1748 32.6652 22.4636 32.2988 22.8182L36.9007 22.9762L33.8293 21.9707Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9246 24.5523L50.521 24.8205L55.1172 26.1227C54.833 25.471 54.4488 24.9329 53.9246 24.5523Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2647 20.4205C38.5123 19.727 38.233 18.5033 39.2704 17.7699C40.2006 17.2239 41.3425 17.4601 41.7403 18.6355C41.7682 17.0506 40.7479 16.3365 39.6585 16.3426C38.3672 16.4199 37.7001 17.3999 37.6223 18.2628C37.5423 19.3746 38.33 20.1523 39.2647 20.4205Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.07 17.1994C47.6702 17.1994 46.5354 18.3326 46.5354 19.7301C46.5354 21.1276 47.6702 22.2608 49.07 22.2608C50.4698 22.2608 51.605 21.1276 51.605 19.7301C51.605 18.3326 50.4698 17.1994 49.07 17.1994Z",
    fill: "#ED1C24"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.039 19.7696C47.6296 18.5701 49.0783 18.6197 49.5989 19.5664C50.0182 20.3353 49.7104 21.5458 48.5817 21.7144C50.2634 22.2696 51.8428 20.1681 50.7635 18.5354C49.3069 16.6775 46.8327 18.082 47.039 19.7696Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0327 13.9747C38.8985 14.1626 39.1831 14.4334 39.3929 14.2969C40.2519 13.4265 41.51 13.3453 42.2116 14.3956C42.3708 14.6717 42.7909 14.4918 42.6589 14.2091C41.8051 12.737 40.1251 12.8621 39.0327 13.9747Z",
    fill: "#ED1C24"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7447 15.1356C47.6061 15.3634 47.8999 15.6206 48.0905 15.4661C48.8424 14.6305 50.1923 14.6774 50.8471 15.9165C51.0045 16.2421 51.4347 16.1039 51.3197 15.7795C50.6189 14.0954 48.6085 14.0647 47.7447 15.1356Z",
    fill: "#ED1C24"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6858 1.75915L42.2947 2.01855C46.1535 4.33421 50.2924 5.63248 54.2526 5.24054C53.6624 2.58868 52.3243 0.674181 48.9473 0.236593C46.8787 -0.00831559 43.7994 0.448584 41.6858 1.75915Z",
    fill: "#ED1C24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_1060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.1f66a274ca30ef45eae45b5907497d2c.svg";
export { ForwardRef as ReactComponent };